import { useTitle } from '@easyvaas/react-hooks';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { abilitiesListSelector } from '../../store/selector';
import styles from './index.module.scss';
const Rules = () => {
  useTitle('规则说明');
  const ablities = useRecoilValue(abilitiesListSelector);
  return (
    <div className={styles.container}>
      <h2>座驾获取</h2>
      <p>
        座驾为进入直播间的座驾形象，分为普通座驾（1阶-3阶）和高级座驾（4阶及以上），座驾通过以下方式获得：
      </p>
      <section>
        <p>
          1、合成：通过【专属碎片】合成座驾，在背包或形象管理内使用，需要达到指定数量
          <br />
          2、兑换：通过【通用碎片】或【宝石】兑换座驾，在形象管理使用，需要达到指定数量
          <br />
          3、活动：不定期活动可以获得限量座驾
          <br />
          4、游戏：游戏积分可以兑换座驾
        </p>
        <p className={styles.accent}>
          【专属碎片】来源：活动，直播间幸运转盘
          <br />
          【通用碎片】来源：活动，座驾分解
          <br />
          【宝石】来源：活动，座驾分解
          <br />
          宝石打磨：将不可转赠的宝石打磨为可以转赠的宝石，打磨材料【磨石】可在商城购买
        </p>
      </section>
      <h2>座驾使用</h2>
      <p>
        已经获取的座驾，可在【形象管理】-【我的】里【设为默认】，即成功使用该座驾作为直播间形象。
      </p>
      <h2>座驾进阶</h2>
      <p>
        【形象管理】-【我的】里，可以进阶的座驾会显示进阶按钮，点击可以进阶
        <br />
        【普通进阶】（1阶进2阶和2阶进3阶）基础成功率50%，5格材料中添加材料每格可以增加5%成功率
        <br />
        每次进阶失败，未添加材料时基础材料将全部消耗，每格材料将减少20%基础材料消耗，建议高阶座驾进阶添加材料提高成功率，降低损失。
        <br />
        每次座驾进阶失败，基础成功率会提高10%，基础成功率最高100%
        <br />
        【高级进阶】（3阶进4阶及以上）进阶只能使用进阶卡，进阶卡成功率即最终成功率
      </p>
      <h2>座驾升星</h2>
      <p>
        活动获得的座驾可以使用升星道具【宠物口粮】升星，【宠物口粮】在活动中获得
        <br />
        座驾初始为0星，最高20星，星级越高，座驾【战斗力】加成越高。
        <br />
        座驾升星有概率失败，座驾0-5星升星失败不会掉星，6星及以上升星失败会掉星。
      </p>
      <h2>座驾属性</h2>
      <p>
        活动获得的座驾有【攻击力】和【生命值】两个属性，座驾属性为随机生成，可以使用道具【九花玉露】
        重置属性，【九花玉露】 在活动中获得 座驾攻击力数值范围: 10-1000
        生命值数值范围: 1000-99999
      </p>
      <h2>座驾天赋</h2>
      <p>
        座驾天赋分为【普通天赋】 和【高阶天赋】
        ，3阶座驾可以获得【普通天赋】，4阶座驾身上可以最多有两个天赋，分别为1个【普通天赋】
        和1个【高阶天赋】
      </p>
      <section>
        <p className={styles.accent} style={{ fontWeight: 600 }}>
          【普通天赋】每个天赋对应不同的战斗系数，影响座驾战斗力
        </p>
        <p>
          {ablities
            .filter(v => !v.isHigh)
            .map(v => (
              <span key={v.talentId}>
                【{v.title}】：{v.desc}
                <br />
              </span>
            ))}
        </p>
        <p className={styles.accent} style={{ fontWeight: 600 }}>
          【高阶天赋】每个天赋对应独立特殊效果，不对战斗力产生影响，【高阶天赋】只在使用这个座驾时生效，同一房间多个高阶座驾，高阶天赋同时生效，相同的高阶天赋不叠加
        </p>
        <p>
          {ablities
            .filter(v => v.isHigh)
            .map(v => (
              <span key={v.talentId}>
                【{v.title}】：{v.desc}
                <br />
              </span>
            ))}
        </p>
        <p className={styles.accent} style={{ fontWeight: 600 }}>
          重置天赋：对座驾天赋不满意时，可以使用【洗髓丹】重置普通天赋，【高级洗髓丹】重置高阶天赋。重置天赋为纯随机，请谨慎操作。【洗髓丹】和【高级洗髓丹】在活动中获得
        </p>
      </section>
      <h2>座驾战斗力</h2>
      <p>
        座驾战斗力与座驾的【攻击力】(生命值】【星级】 【士气值】
        【天赋】相关，还可以通过鼓舞获得战斗力加成
      </p>
      <h2>座驾战</h2>
      <p>
        直播间会展示尊贵形象位置，拥有战斗力座驾的用户，可以抢夺座驾位座驾战，可以通过(鼓舞】获得士气值加成，鼓舞后的座驾战失败不会【虚弱】
        ，【虚弱】 需要使用【大还丹】解除，每层虚弱降低0.3士气值
      </p>
    </div>
  );
};

export default Rules;
